import moment from 'moment';

import {
    formatTimestampForTimeline,
    getTimezoneAbbreviation,
    uncapitalizeMomentString,
    isToday,
    isTomorrow,
} from 'nutshell-core/date-time';

import type {CTABanner_demioEvent as DemioEvent} from 'nutshell-graphql-types';

const PARTY_POPPER = '\u{1F389}';

/**
 * Return a nice readable string
 * If user is registered:
 * 'You're registered for the webcast tomorrow at 12:00 EST' or
 * 'You're registered for the webcast on Thursday, Nov 10 at 12:00 EST'
 *
 * If user isn't registered:
 * 'Nutshell Basics is tomorrow at 12:00 EST' or
 * 'Nutshell Basics on Thursday, Nov 10 at 12:00 EST'
 *  */
export function getTitle(title: string, demioEvent: DemioEvent): string {
    const timezoneAbbreviation = getTimezoneAbbreviation(demioEvent.timestamp);
    const isEventToday = demioEvent.timestamp ? isToday(moment.unix(demioEvent.timestamp)) : false;
    const isEventTomorrow = demioEvent.timestamp
        ? isTomorrow(moment.unix(demioEvent.timestamp))
        : false;

    const isTodayOrTomorrow = isEventToday || isEventTomorrow;

    const eventTime = uncapitalizeMomentString(
        `${formatTimestampForTimeline(demioEvent.timestamp)} ${timezoneAbbreviation || ''}`
    );

    return demioEvent.isCurrentUserRegistered
        ? `${PARTY_POPPER} You’re registered for the webcast ${
              isTodayOrTomorrow ? '' : 'on'
          } ${eventTime}`
        : `${title} ${isTodayOrTomorrow ? 'is' : 'on'} ${eventTime}`;
}

export function getSubtitle(subtitle: string, demioEvent: DemioEvent): string {
    if (demioEvent.isCurrentUserRegistered) {
        return 'Check your email for details on how to join';
    }

    return subtitle;
}
